export default __webpack_public_path__ + "abef3228d5ef35b80d2ab63002ca9243.png";